/* eslint-disable no-redeclare */
import {
  Placement,
  ProductType,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { AdDto } from '../../dto/ad.types';

export const TrackClickResponseDto = z.object({
  data: z.string(),
  error: z.string().nullable(),
  status: z.number(),
});

export type TrackClickResponseDto = z.infer<typeof TrackClickResponseDto>;

export const TrackClickRequestDto = AdDto.extend({
  click_count: z.number(),
  complete_url: z.string().url(),
  device: z.enum(['Desktop', 'Mobile', 'Tablet', 'Computer']),
  impression_id: z.string(),
  placement: Placement,
  product: ProductType,
  ranking_type: z.literal('none'),
  repeated: z.enum(['true', 'false']),
  session_id: z.string(),
  state: USAStateAcronym,
  zipcode: ZipCode,
});

export type TrackClickRequestDto = z.infer<typeof TrackClickRequestDto>;
